import React from "react";

import { cn } from "@/lib/cn";

/** An icon button in the panel's header; under a finger it grows to a 44px target around the same icon. */
export const ActionButton = ({
  className,
  type = "button",
  ...props
}: React.ComponentProps<"button">) => (
  <button
    type={type}
    className={cn(
      "flex h-6 w-6 cursor-pointer items-center justify-center border-none bg-transparent p-0 text-muted-foreground rounded-lg focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:text-muted-foreground/50 [&_svg]:h-auto [&_svg]:w-5 pointer-coarse:size-11",
      className,
    )}
    {...props}
  />
);
